function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("title", null, "VF_phone_charging_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M255.1 0H127.6C112 0 99.3 12.7 99.3 28.3v226.8c0 15.6 12.7 28.3 28.3 28.3h127.6c15.6 0 28.3-12.7 28.3-28.3V28.3c0-15.6-12.8-28.3-28.4-28.3zm0 255.1H127.6V28.3h127.6v226.8h-.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M170.1 42.5h42.5v14.2h-42.5zM56.7 0L0 70.9h33.4l-12.1 42.5L78 42.5H44.5z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "191.3",
  cy: "223.2",
  r: "17.8"
})));